import { ButtonTertiary } from '@spotify-internal/encore-web';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import withTranslation from 'lib/shared/i18n/withTranslation';

const style = { paddingLeft: '0px' };

const BackButton = ({ t, handleBackButton }) => (
  <ButtonTertiary style={style} onClick={handleBackButton}>
    <span className="rtl-flip">&larr;</span> {t('back_button_label')}
  </ButtonTertiary>
);

BackButton.propTypes = {
  t: PropTypes.func.isRequired,
  handleBackButton: PropTypes.func.isRequired,
};

export default withTranslation('infringement_claim_form')(withRouter(BackButton));
